namespace TabAurous.Purchase {
    export namespace MonthlyReportService {
        export const baseUrl = 'Purchase/MonthlyReport';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function KaratList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/MonthlyReport/List",
            KaratList = "Purchase/MonthlyReport/KaratList"
        }

        [
            'List', 
            'KaratList'
        ].forEach(x => {
            (<any>MonthlyReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
